export const server = {
  // apiURL: window.location.origin.includes('cs.justdial.com')
  //   ? `${window.location.origin}/api/v1/`
  //   : 'https://cs.justdial.com/api/v1/',
  apiURL: `${window.location.origin}/api/v1/`,
  genioRedirectionUrl: process.env.REACT_APP_GENIO_REDIRECTION_URL,
  traceUrl: process.env.REACT_APP_TRACEURL,
  logsUrl: process.env.REACT_APP_TRACELOGS,
};
